

import Vue from 'vue'
import App from './App'
import router from './router'
import {axiosApi, publicFun} from '@/assets/js/publicFunc.js'
import {apiUrl} from '@/assets/js/config.js';
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import VueClipboard from 'vue-clipboard2'



Vue.use(AlertPlugin)
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(VueClipboard)
Vue.config.productionTip = false

Vue.prototype.$post = axiosApi.request;
Vue.prototype.$upload = axiosApi.upload;
Vue.prototype.$apiUrl = apiUrl;
Vue.prototype.$utils = publicFun;
Vue.use(require('vue-wechat-title'))
/* eslint-disable no-new */
new Vue({
el: '#app',
router,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js